import { PublicDeleteUserFile, PublicDeleteUserImageByUserAndAccessMethod } from '../../../reduxToolkit/Invitation/InvitationApi';
import { accessMethodModel } from '../../../enums/accessMethodEnum';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {ValidationProcessCancel} from '../../../reduxToolkit/Visitor/VisitorApi';
import {useParams} from "react-router-dom";
import {getMainUrl} from "../Model/Models";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param model getInvitationById: Model that contains all the information of the invitation.
 * @param String validationId: id of veridas.
 */
const HandleDeleteVeridasApp = ({ getInvitationById, validationId }) => {
    const { guardFlowId, userId, eventId } = useParams();
    const invitationId = getInvitationById?.invitation?.id;
    const mainUrl = getMainUrl({ invitationId, eventId, guardFlowId });
    const resolvedUserId  = userId ? userId: getInvitationById?.invitation?.visitorId;
    const dispatch = useDispatch();

    useEffect(() => {
        localStorage.setItem('visitorId', resolvedUserId);
        localStorage.setItem('validationId', validationId);
    }, []);


    useEffect(() => {
        if (getInvitationById?.invitation?.id) {
            localStorage.setItem('visitorId', getInvitationById?.invitation?.visitorId);
            localStorage.setItem('invitationId', getInvitationById?.invitation?.id);
        }
    }, [getInvitationById]);

    const handleDelete = () => {
        const userId = localStorage.getItem('visitorId');
        const validation = localStorage.getItem('validationId');

        if(userId){
            dispatch(PublicDeleteUserFile(userId));
            dispatch(PublicDeleteUserImageByUserAndAccessMethod({
                userId,
                accessMethodId: accessMethodModel.FACE_RECOGNITION.id
            }));
        }
        if(validation)
            dispatch(ValidationProcessCancel(validation));
    }

    const handleDeleteStorage = () => {
        localStorage.removeItem('visitorId');
        localStorage.removeItem('invitationId');
        localStorage.removeItem('validationId');
    }

    return {
        handleDelete,
        handleDeleteStorage,
        mainUrl
    }

};

export default HandleDeleteVeridasApp
